import React, { useState, KeyboardEvent, useEffect } from 'react';
import { TextField, IconButton, InputAdornment, Box } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Routes } from '../router/constants';

export const GlobalSearchInput = () => {
  const [searchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('search') || '');
  const navigate = useNavigate();
  const { t } = useTranslation(undefined, {
    keyPrefix: 'common.search',
  });

  useEffect(() => {
    const search = searchParams.get('search');
    if (search && search !== query) {
      setQuery(search);
    }
  }, [searchParams]);

  const handleSearch = () => {
    if (query.trim() !== '') {
      navigate(
        `${Routes.search.path}?search=${encodeURIComponent(query.trim())}`,
      );
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && query.trim() !== '') {
      handleSearch();
    }
  };

  return (
    <Box>
      <TextField
        fullWidth
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t('placeholder')}
        variant="outlined"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleSearch}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default GlobalSearchInput;
